export default "__VITE_ASSET__CdyNixG5__"